module.exports = __webpack_public_path__ + "img/daily_4.d7aff2d0.png";